module.exports = __webpack_public_path__ + "static/media/d23ru.86117412.pdf";